import generator from '../util/generator';

export default generator.generate('', 'fontStyle', [
    ['not-italic', 'normal'],
    'italic',
]);
